<template>
  <el-dialog
    width="60%"
    class="dialog"
    title="下载中心"
    :visible.sync="visible"
    :modal-append-to-body="false"
    :before-close="closeDialog"
  >
    <div class="tips">提示:文件将在下载中心保留7天。</div>
    <el-table :data="list">
      <el-table-column prop="operation" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-show="scope.row.status == 'SUCCESS'"
            @click="downLoad(scope.row.downloadFileName)"
            >下载</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="fileName"
        label="文件名"
        width="200"
      ></el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <span class="status-dot" :class="{'error': scope.row.status === 'FAIL'}"></span>
          {{ statusMap[scope.row.status] }}
        </template>
      </el-table-column>
      <el-table-column prop="fileType" label="来源" width="200">
        <template slot-scope="scope">
          {{ sourceMap[scope.row.fileType] }}
        </template>
      </el-table-column>
      <el-table-column prop="createdDate" label="提交时间">
        <template slot-scope="scope">
          {{ scope.row.createdDate | formatDateTimeDefault }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.size"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="refresh">刷新</el-button>

      <el-button type="primary" pain @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { downLoadCenter } from "@/api/user";

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: { page: 1, size: 10 },
      list: [],
      total: 0,
      statusMap: {
        INIT: "初始化",
        RUN: "导出中",
        FAIL: "导出失败",
        SUCCESS: "可下载",
      },
      sourceMap: {
        USER_ORDER: "用户下单管理-导出",
      },
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getList();
      } else {
        this.search.page = 1;
        this.search.size = 10;
        this.list = [];
      }
    },
  },
  methods: {
    // 打开弹框
    async getList() {
      let { data, statusCode, total } = await downLoadCenter(this.search);
      if (statusCode == 200) {
        this.list = data;
        this.total = total;
      }
      this.visible = true;
    },

    handleSizeChange(val) {
      this.search.page = 1;
      this.search.size = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    formatImgUrl(value) {
      return (
        process.env.BASE_API +
        `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${value}`
      );
    },
    async downloadQuoteFile(row) {
      let url =
        process.env.BASE_API +
        `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${row.reportPriceUrl}`;

      window.open(url, "_blank");
    },
    //刷新列表
    refresh() {
      // this.search.page = 1;
      this.getList();
    },
    downLoad(downloadFileName) {
      let downLoadUrl = `${process.env.BASE_API}/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${downloadFileName}`;

      window.open(downLoadUrl, "_blank");

      return;
      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/tblRecycleOrder/exportOrderById`,
          params,
          "订单明细表"
        )
        .catch((res) => {
          let blob = new Blob([res.response.data], {
            type: "application/json",
          });
          var blobReader = new Response(blob).json();
          blobReader.then((res) => {
            this.$message.error(res.message);
          });
        });
    },
    // 关闭弹框
    closeDialog() {
      this.$emit("update:visible");
    },
  },
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    paddding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
.status-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #00B882;
  margin-right: 3px;
  vertical-align: middle;

  &.error {
    background-color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/download-center.vue